var _style, _g, _path, _defs, _g2, _g3, _path2, _defs2, _g4, _g5, _polygon, _defs3, _g6, _g7, _path3, _defs4, _g8, _g9, _path4, _defs5, _g0, _g1, _path5, _defs6, _g10, _g11;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBitcoin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 800 550",
    style: {
      enableBackground: "new 0 0 800 550"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.Graphic_x0020_Style{fill:url(#SVGID_1_);}\n\t.Graphic_x0020_Style_x0020_2{fill:#D1D7E0;}\n\t.st0{display:none;}\n\t.st1{display:inline;fill:#FFFFFF;}\n\t.st2{display:inline;fill:url(#SVGID_00000062878735123133319960000011815328772640972968_);}\n\t.st3{display:inline;filter:url(#Adobe_OpacityMaskFilter);}\n\t.st4{fill:url(#SVGID_00000134229055049728175030000009882283410407721857_);}\n\t.st5{display:inline;mask:url(#SVGID_00000152262068644707505780000002778101634725979264_);}\n\t.st6{display:inline;fill:url(#SVGID_00000074408279751332216240000002802463884414231184_);}\n\t.st7{display:inline;filter:url(#Adobe_OpacityMaskFilter_00000082365407805601323050000004918524630326111136_);}\n\t.st8{fill:url(#SVGID_00000000190993530900161740000015298225069218539189_);}\n\t.st9{display:inline;mask:url(#SVGID_00000044137066611506589310000012035430419225359784_);}\n\t.st10{display:inline;fill:url(#SVGID_00000002360349728724744230000009453056034887743677_);}\n\t.st11{display:inline;filter:url(#Adobe_OpacityMaskFilter_00000047742069278719693530000012682229256431607441_);}\n\t.st12{fill:url(#SVGID_00000082336770169281003550000010823700209814179215_);}\n\t.st13{display:inline;mask:url(#SVGID_00000100364327279352020270000012839744454469964698_);}\n\t.st14{display:inline;fill:url(#SVGID_00000135667915579482941840000001740113053399504277_);}\n\t.st15{display:inline;filter:url(#Adobe_OpacityMaskFilter_00000006694281345026005990000013495066948334495380_);}\n\t.st16{fill:url(#SVGID_00000083804002574200528580000014243422451191704249_);}\n\t.st17{display:inline;mask:url(#SVGID_00000016772031422804655460000014475487712789846447_);}\n\t.st18{display:inline;fill:url(#SVGID_00000137130298214916520730000010152992182559747219_);}\n\t.st19{display:inline;filter:url(#Adobe_OpacityMaskFilter_00000052071790652838147980000012702969970673598594_);}\n\t.st20{fill:url(#SVGID_00000114070873751354160880000005491878660655967620_);}\n\t.st21{display:inline;mask:url(#SVGID_00000145025107317609032450000011298220913953723566_);}\n\t.st22{fill:url(#SVGID_00000111185732462176907400000008896458047301617570_);}\n\t.st23{fill:#FFFFFF;}\n\t.st24{filter:url(#Adobe_OpacityMaskFilter_00000141456128949522874800000011218249789449748143_);}\n\t.st25{fill:url(#SVGID_00000085233969487477788490000009162702122113771945_);}\n\t.st26{mask:url(#SVGID_00000170959185684693333310000004303536246283621252_);}\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 100,
    y1: -25,
    x2: 99.8174,
    y2: -25.9832
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1A3763"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BCBEC0"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BG",
    className: "st0"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    width: 800,
    height: 550
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_x31_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000181062077592017454730000001965482124706350728_",
    gradientUnits: "userSpaceOnUse",
    x1: 194.2919,
    y1: 339.6855,
    x2: 132.8855,
    y2: 8.9977
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1A3763"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BCBEC0"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      display: "inline",
      fill: "url(#SVGID_00000181062077592017454730000001965482124706350728_)"
    },
    cx: 160,
    cy: 155,
    r: 100
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M148.58,218.34v-9.72l-4.28-0.91l-3.11-0.73c-1.03-0.23-2-0.49-2.91-0.75l-1.05-0.29 c-0.73-0.19-1.33-0.35-1.91-0.53l-3-0.94c-0.64-0.19-1.22-0.4-1.78-0.6l-3.3-1.2l-3.08-1.24c1.68-6.83,3.3-13.57,4.89-20.14 l1.11-4.62c1.45,0.74,2.9,1.4,4.31,1.99c3.33,1.4,6.71,2.55,10.05,3.42c3.02,0.8,6.65,1.66,10.56,2.02l0.36,0.03 c0.92,0.06,1.52,0.08,2.12,0.08l0.52-0.01c0.78-0.03,1.1-0.04,1.61-0.1c0.52-0.04,1.1-0.13,1.7-0.26 c1.58-0.34,2.89-0.92,4.02-1.75c1.64-1.25,2.49-2.8,2.92-3.89c0.42-1.13,0.82-2.18,0.92-3.85c0.07-1.8-0.38-3.54-1.28-4.97 c-0.7-1.14-1.66-2.16-2.94-3.06c-0.99-0.7-2.03-1.24-3.29-1.7l-16.66-5.67l-1.91-0.86c-1.19-0.54-2.82-1.3-4.42-2.07l-1.05-0.52 l-0.75-0.41c-0.22-0.14-0.43-0.26-0.65-0.38c-0.59-0.34-1.02-0.59-1.4-0.85c-1.83-1.18-3.45-2.43-4.88-3.74 c-0.69-0.63-1.33-1.28-1.94-1.94l-0.22-0.23c-0.24-0.28-0.4-0.46-0.55-0.65c-0.38-0.47-0.57-0.71-0.78-0.95 c-0.13-0.18-1.22-1.72-1.22-1.72c-0.38-0.6-0.72-1.15-1.03-1.71c-0.38-0.68-0.69-1.36-0.95-1.93c-1.15-2.69-1.76-5.36-1.9-8.14 c-0.03-0.5-0.04-0.73-0.04-0.96c-0.03-0.59-0.02-0.87-0.01-1.18c0-0.91,0.02-1.71,0.05-2.47c0.05-1.6,0.15-2.91,0.45-4.16 c0.16-0.68,0.34-1.46,0.56-2.22l0.27-0.94l0.42-1.28c0.41-1.18,1.03-2.52,1.75-3.82c1.35-2.45,3.16-4.73,5.37-6.78 c1.1-1.03,2.26-1.97,3.45-2.81c0.52-0.38,1.04-0.73,1.55-1.05l0.38-0.25c0.57-0.34,1.25-0.76,1.91-1.12 c2.74-1.54,5.49-2.64,8.23-3.29l3.15-0.75v-8.1h22.38v7.14l2.76,0.48l3.39,0.64l3.02,0.66l3.02,0.73l2.98,0.81l2.96,0.89 l2.93,0.96l2.59,0.92l-6.41,23.41l-1.72-0.91c-0.36-0.19-0.68-0.34-1.02-0.5l-0.26-0.12c-0.7-0.32-1.44-0.64-2.42-1.05 c-3.59-1.47-6.84-2.58-9.96-3.4c-1.06-0.26-1.9-0.45-2.75-0.6c-0.78-0.16-1.69-0.26-2.57-0.36c-1.36-0.13-2.41-0.19-3.4-0.19 c-0.44,0-0.87,0.01-1.3,0.03c-0.38,0.02-0.79,0.05-1.19,0.08c-2.59,0.24-4.63,0.86-6.41,1.96c-1.12,0.72-2.01,1.55-2.68,2.49 l-0.21,0.32c-0.57,0.96-0.86,1.67-1.04,2.39c-0.1,0.47-0.17,0.82-0.22,1.18l-0.03,0.36l-0.01,0.63c-0.04,1.22,0.27,2.59,0.86,3.68 c0.51,0.97,1.25,1.85,2.26,2.64c1.41,1.04,2.92,1.73,4.82,2.24c2.39,0.56,4.57,1.18,7.14,1.95c5.49,1.69,9.8,3.29,13.52,5.05 c1.68,0.8,3.87,1.92,5.76,3.35l1.64,1.17c0.15,0.11,1.09,0.87,1.09,0.87c0.98,0.82,1.77,1.57,2.44,2.31 c1.51,1.61,2.82,3.39,3.95,5.32l0.82,1.52l0.23,0.49c0.13,0.25,0.27,0.52,0.37,0.78c0.13,0.34,0.22,0.54,0.3,0.73 c0.15,0.36,0.24,0.57,0.31,0.79l0.57,1.7c0.57,1.95,0.94,4.15,1.1,6.47c0.05,0.56,0.05,1.09,0.05,1.61l0.02,1 c0,0.11-0.01,0.41-0.03,0.64c-0.04,1.38-0.17,2.51-0.29,3.44l-0.27,1.71l-0.34,1.66l-0.41,1.74l-0.45,1.58 c-0.65,2.07-1.53,4.11-2.61,6.01c-2.14,3.73-5.22,7.1-8.91,9.74c-0.42,0.32-0.75,0.54-1.07,0.75l-0.4,0.26 c-0.42,0.29-0.88,0.57-1.35,0.84c-1.19,0.74-2.21,1.31-3.11,1.78c-1.91,0.95-4.02,1.84-6.26,2.44l-1.52,0.45v10.95H148.58z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: 124.16,
    y: 104.9,
    width: 134.83,
    height: 148.73
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 124.16,
    y: 104.9,
    width: 134.83,
    height: 148.73,
    id: "SVGID_00000001637971406817864710000000455479312028768156_",
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter)"
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000003065097179859325440000017213389506596982682_",
    gradientUnits: "userSpaceOnUse",
    x1: 131.6264,
    y1: 128.3881,
    x2: 249.57,
    y2: 239.3701,
    gradientTransform: "matrix(0.9137 -0.0863 -0.0863 0.9137 28.619 28.619)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1084,
    style: {
      stopColor: "#FBFBFB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2161,
    style: {
      stopColor: "#EFEFEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3234,
    style: {
      stopColor: "#DBDBDB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4307,
    style: {
      stopColor: "#BFBFBF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5379,
    style: {
      stopColor: "#9B9B9B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6451,
    style: {
      stopColor: "#6F6F6F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7507,
    style: {
      stopColor: "#3B3B3B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8563,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000003065097179859325440000017213389506596982682_)"
    },
    points: "277.45,182.2 188.92,270.73  96.35,178.16 184.88,89.63  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline",
      mask: "url(#SVGID_00000001637971406817864710000000455479312028768156_)"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "Graphic_x0020_Style_x0020_2",
    d: "M165.04,166.31c-0.99-0.7-2.03-1.24-3.29-1.7l-16.66-5.67l-1.91-0.86 c-1.19-0.54-2.82-1.3-4.42-2.07l-1.05-0.52l-0.75-0.41c-0.22-0.14-0.43-0.26-0.65-0.38c-0.59-0.34-1.02-0.59-1.4-0.85 c-1.83-1.18-3.45-2.43-4.88-3.74l33.16,33.16c0.81-0.32,1.57-0.69,2.23-1.19c1.64-1.25,2.49-2.8,2.92-3.89 c0.42-1.13,0.82-2.18,0.92-3.85c0.07-1.8-0.38-3.54-1.28-4.97C167.28,168.23,166.31,167.22,165.04,166.31z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Graphic_x0020_Style_x0020_2",
    d: "M194.96,104.9l-0.02,0.01l0.01,0l-6.41,23.41l-1.72-0.91 c-0.36-0.19-0.68-0.34-1.02-0.5l-0.26-0.12c-0.7-0.32-1.44-0.64-2.42-1.05c-3.59-1.47-6.84-2.58-9.96-3.4 c-1.06-0.26-1.9-0.45-2.75-0.6c-0.78-0.16-1.69-0.26-2.57-0.36c-1.36-0.13-2.41-0.19-3.4-0.19c-0.44,0-0.87,0.01-1.3,0.03 c-0.38,0.02-0.79,0.05-1.19,0.08c-2.59,0.24-4.63,0.86-6.41,1.96c-1.12,0.72-2.01,1.55-2.68,2.49l-0.21,0.32 c-0.57,0.96-0.86,1.67-1.04,2.39c-0.1,0.47-0.17,0.82-0.22,1.18l-0.03,0.36l-0.01,0.63c-0.04,1.22,0.27,2.59,0.86,3.68 c0.51,0.97,1.25,1.85,2.26,2.64c1.41,1.04,2.92,1.73,4.82,2.24c2.39,0.56,4.57,1.18,7.14,1.95c5.49,1.69,9.8,3.29,13.52,5.05 c1.68,0.8,3.87,1.92,5.76,3.35l1.64,1.17c0.15,0.11,1.09,0.87,1.09,0.87c0.98,0.82,1.77,1.57,2.44,2.31 c1.51,1.61,2.82,3.39,3.95,5.32l0.82,1.52l0.23,0.49c0.13,0.25,0.27,0.52,0.37,0.78c0.13,0.34,0.22,0.54,0.3,0.73 c0.15,0.36,0.24,0.57,0.31,0.79l0.57,1.7c0.57,1.95,0.94,4.15,1.1,6.47c0.05,0.56,0.05,1.09,0.05,1.61l0.02,1 c0,0.11-0.01,0.41-0.03,0.64c-0.04,1.38-0.17,2.51-0.29,3.44l-0.27,1.71l-0.34,1.66l-0.41,1.74l-0.45,1.58 c-0.65,2.07-1.53,4.11-2.61,6.01c-2.14,3.73-5.22,7.1-8.91,9.74c-0.42,0.32-0.75,0.54-1.07,0.75l-0.4,0.26 c-0.42,0.29-0.88,0.57-1.35,0.84c-1.19,0.74-2.21,1.31-3.11,1.78c-1.91,0.95-4.02,1.84-6.26,2.44l-1.52,0.45v10.95h-23.01v-9.72 l-4.28-0.91l-3.11-0.73c-1.03-0.23-2-0.49-2.91-0.75l-1.05-0.29c-0.73-0.19-1.33-0.35-1.91-0.53l-3-0.95 c-0.64-0.19-1.22-0.4-1.78-0.6l-3.3-1.2l-3.07-1.24l-0.01,0l52.2,52.2c42.87-7.07,76.6-41.5,82.63-84.7L194.96,104.9z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "Graphic_x0020_Style_x0020_2",
    d: "M165.04,166.31c-0.99-0.7-2.03-1.24-3.29-1.7l-16.66-5.67l-1.91-0.86 c-1.19-0.54-2.82-1.3-4.42-2.07l-1.05-0.52l-0.75-0.41c-0.22-0.14-0.43-0.26-0.65-0.38c-0.59-0.34-1.02-0.59-1.4-0.85 c-1.83-1.18-3.45-2.43-4.88-3.74l33.16,33.16c0.81-0.32,1.57-0.69,2.23-1.19c1.64-1.25,2.49-2.8,2.92-3.89 c0.42-1.13,0.82-2.18,0.92-3.85c0.07-1.8-0.38-3.54-1.28-4.97C167.28,168.23,166.31,167.22,165.04,166.31z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Graphic_x0020_Style_x0020_2",
    d: "M194.96,104.9l-0.02,0.01l0.01,0l-6.41,23.41l-1.72-0.91 c-0.36-0.19-0.68-0.34-1.02-0.5l-0.26-0.12c-0.7-0.32-1.44-0.64-2.42-1.05c-3.59-1.47-6.84-2.58-9.96-3.4 c-1.06-0.26-1.9-0.45-2.75-0.6c-0.78-0.16-1.69-0.26-2.57-0.36c-1.36-0.13-2.41-0.19-3.4-0.19c-0.44,0-0.87,0.01-1.3,0.03 c-0.38,0.02-0.79,0.05-1.19,0.08c-2.59,0.24-4.63,0.86-6.41,1.96c-1.12,0.72-2.01,1.55-2.68,2.49l-0.21,0.32 c-0.57,0.96-0.86,1.67-1.04,2.39c-0.1,0.47-0.17,0.82-0.22,1.18l-0.03,0.36l-0.01,0.63c-0.04,1.22,0.27,2.59,0.86,3.68 c0.51,0.97,1.25,1.85,2.26,2.64c1.41,1.04,2.92,1.73,4.82,2.24c2.39,0.56,4.57,1.18,7.14,1.95c5.49,1.69,9.8,3.29,13.52,5.05 c1.68,0.8,3.87,1.92,5.76,3.35l1.64,1.17c0.15,0.11,1.09,0.87,1.09,0.87c0.98,0.82,1.77,1.57,2.44,2.31 c1.51,1.61,2.82,3.39,3.95,5.32l0.82,1.52l0.23,0.49c0.13,0.25,0.27,0.52,0.37,0.78c0.13,0.34,0.22,0.54,0.3,0.73 c0.15,0.36,0.24,0.57,0.31,0.79l0.57,1.7c0.57,1.95,0.94,4.15,1.1,6.47c0.05,0.56,0.05,1.09,0.05,1.61l0.02,1 c0,0.11-0.01,0.41-0.03,0.64c-0.04,1.38-0.17,2.51-0.29,3.44l-0.27,1.71l-0.34,1.66l-0.41,1.74l-0.45,1.58 c-0.65,2.07-1.53,4.11-2.61,6.01c-2.14,3.73-5.22,7.1-8.91,9.74c-0.42,0.32-0.75,0.54-1.07,0.75l-0.4,0.26 c-0.42,0.29-0.88,0.57-1.35,0.84c-1.19,0.74-2.21,1.31-3.11,1.78c-1.91,0.95-4.02,1.84-6.26,2.44l-1.52,0.45v10.95h-23.01v-9.72 l-4.28-0.91l-3.11-0.73c-1.03-0.23-2-0.49-2.91-0.75l-1.05-0.29c-0.73-0.19-1.33-0.35-1.91-0.53l-3-0.95 c-0.64-0.19-1.22-0.4-1.78-0.6l-3.3-1.2l-3.07-1.24l-0.01,0l52.2,52.2c42.87-7.07,76.6-41.5,82.63-84.7L194.96,104.9z"
  }))))), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000029019383922571476460000015772178597418872763_",
    gradientUnits: "userSpaceOnUse",
    x1: 434.2919,
    y1: 339.6855,
    x2: 372.8855,
    y2: 8.9977
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1A3763"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BCBEC0"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      display: "inline",
      fill: "url(#SVGID_00000029019383922571476460000015772178597418872763_)"
    },
    cx: 400,
    cy: 155,
    r: 100
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M405.6,215.23c-0.57,0-1.14-0.02-1.69-0.05c-2.79-0.17-5-0.45-6.94-0.86c-2.57-0.53-4.77-1.14-6.76-1.84 c-0.8-0.24-1.56-0.53-2.29-0.81c-0.35-0.14-0.74-0.29-1.13-0.43l-3.88-1.63l-0.47-0.22c-0.69-0.33-1.39-0.65-2.07-1l-0.88-0.47 c-0.73-0.38-1.44-0.76-2.15-1.19l-3.41-2.16c-0.86-0.6-1.63-1.14-2.36-1.74l-1.41-1.12c-0.23-0.2-0.5-0.43-0.75-0.67l-1.8-1.62 l-1.68-1.67c-0.26-0.26-0.52-0.52-0.71-0.75l-1.96-2.18c-0.52-0.57-1.06-1.17-1.53-1.79c0,0-1.82-2.26-2.21-2.76l-1.97-2.8 l-1.78-2.98c-0.18-0.29-0.32-0.58-0.46-0.88L355,183c-0.3-0.57-0.51-1.04-0.71-1.5c-0.98-2.14-1.76-4.45-2.43-6.45l-0.57-1.8 h-12.7l1.99-12.29h8.69l-0.11-1.73c-0.04-0.71-0.25-4.43,0.21-7.56l0.27-1.86H338.6l1.99-12.31c0,0,9.66,0,11.61,0 c1.1-3.12,1.99-5.22,2.4-6.14c0.29-0.58,0.58-1.22,0.88-1.85l0.18-0.38c0.37-0.78,0.73-1.56,1.12-2.3l1.15-2.2 c0.21-0.38,1.89-3.19,1.89-3.19l0.67-0.96c0.23-0.3,0.46-0.64,0.69-0.98l0.74-1.06l0.79-0.99c0.79-1,1.5-1.91,2.32-2.76 c0.93-1.1,1.97-2.09,2.98-3.05l0.52-0.5c0.33-0.33,0.67-0.62,1.01-0.91l1.75-1.5l2.97-2.22l4.34-2.68l4.9-2.55l1.69-0.63 c1.64-0.63,3.19-1.14,4.76-1.58c0.72-0.22,1.41-0.38,2.09-0.54c0.96-0.24,1.56-0.35,2.14-0.46l0.64-0.12 c1.5-0.27,3.15-0.47,4.9-0.6c0.48-0.05,0.97-0.05,1.44-0.06c0.55,0,1.52-0.02,1.52-0.02c0.38,0,0.79,0.02,1.18,0.04l1.89,0.08 c0.69,0.03,1.07,0.04,1.47,0.08l5.09,0.58l4.64,0.85l1.95-3.69c5.43,2.23,10.87,4.43,16.32,6.63l6.58,2.66l-9.95,23.82l-0.33-0.22 l-3.25-1.85l-3.38-1.64c-0.87-0.38-1.72-0.73-2.57-1.06l-0.91-0.37c-0.85-0.32-1.7-0.59-2.55-0.86l-1.05-0.34 c-0.94-0.26-1.85-0.48-2.77-0.68l-0.94-0.22c-0.76-0.17-1.55-0.28-2.32-0.38l-1.49-0.22c-0.9-0.1-1.72-0.13-2.5-0.17l-2-0.08 c-1.09,0-2.12,0.07-3.28,0.2c-1.32,0.15-2.62,0.37-3.87,0.68c-1.09,0.26-2.28,0.62-3.72,1.15c-1.17,0.45-2.32,0.97-3.54,1.59 c-0.29,0.15-0.58,0.31-0.86,0.48l-0.83,0.49c-0.38,0.22-0.78,0.47-1.17,0.74l-0.44,0.28l-1.55,1.14l-1.47,1.22l-1.4,1.29 l-1.32,1.35l-1.24,1.44c0,0-2.07,2.41-3.68,5.14c1.68,0,43.85,0.06,43.85,0.06l-1.94,12.24c-7.36,0.01-41.97,0.05-45.1,0.05 c-0.51,1.77-0.62,3.82-0.61,5.62c0.01,2.1,0.22,3.91,0.67,5.54c1.4,0,43.27,0,43.27,0l-1.95,12.29c0,0-33.75,0-38.19,0 c0.97,2.69,4.68,6.76,4.68,6.76l1.29,1.32l1.39,1.27l1.45,1.19l1.54,1.11l1.57,1.02l1.65,0.93l1.7,0.85l1.76,0.73l1.81,0.62 l1.82,0.52l1.89,0.41l1.89,0.29l1.95,0.17l1.86,0.05l2.01-0.08c0.65-0.02,1.31-0.05,1.96-0.09l2.45-0.31 c0.72-0.09,1.13-0.14,1.53-0.23l2.52-0.56c0.47-0.09,0.92-0.2,1.35-0.34l1.84-0.59c0.25-0.1,0.42-0.14,0.58-0.2 c0.67-0.22,1.05-0.35,1.38-0.51l2.38-1.06c0.41-0.17,0.85-0.37,1.23-0.63l2.04-1.18c0.58-0.32,0.98-0.55,1.33-0.82l1.92-1.41 c0.45-0.32,0.85-0.61,1.2-0.93l0.63-0.58l9.93,20.87l-2.05,1.67c-0.22,0.2-0.38,0.33-0.55,0.46c0,0-3.31,2.29-3.62,2.49 l-2.37,1.39c-0.67,0.4-1.37,0.82-2.16,1.17l-1.65,0.78c-0.54,0.26-1.08,0.52-1.59,0.73l-3.34,1.25c-0.68,0.28-1.35,0.47-2,0.65 c-0.57,0.16-0.98,0.27-1.39,0.41l-0.52,0.15c-0.38,0.12-0.75,0.23-1.13,0.32l-4.32,0.94l-4.49,0.63 C409.29,215.06,407.47,215.23,405.6,215.23z"
  })), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000077320425513636145240000012374669614176051877_",
    filterUnits: "userSpaceOnUse",
    x: 338.6,
    y: 104.53,
    width: 161.1,
    height: 148.7
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 338.6,
    y: 104.53,
    width: 161.1,
    height: 148.7,
    id: "SVGID_00000067196499340828926490000016352162727714328221_",
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000077320425513636145240000012374669614176051877_)"
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000139999652949831799140000001197423834960180900_",
    gradientUnits: "userSpaceOnUse",
    x1: 365.8613,
    y1: 117.8321,
    x2: 478.9272,
    y2: 224.2245,
    gradientTransform: "matrix(0.9961 -3.900000e-03 -3.900000e-03 0.9961 1.5151 1.5151)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1084,
    style: {
      stopColor: "#FBFBFB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2161,
    style: {
      stopColor: "#EFEFEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3234,
    style: {
      stopColor: "#DBDBDB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4307,
    style: {
      stopColor: "#BFBFBF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5379,
    style: {
      stopColor: "#9B9B9B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6451,
    style: {
      stopColor: "#6F6F6F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7507,
    style: {
      stopColor: "#3B3B3B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8563,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000139999652949831799140000001197423834960180900_)"
    },
    points: "519.86,178.22 429.58,268.49  323.33,162.24 413.61,71.97  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline",
      mask: "url(#SVGID_00000067196499340828926490000016352162727714328221_)"
    }
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "Graphic_x0020_Style_x0020_2",
    d: "M349.17,159.23c-0.04-0.71-0.25-4.43,0.21-7.56l0.27-1.86H338.6l10.65,10.65 L349.17,159.23z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Graphic_x0020_Style_x0020_2",
    d: "M441.8,104.53L441.8,104.53l-9.95,23.81l-0.33-0.22l-3.25-1.85l-3.38-1.64 c-0.87-0.38-1.72-0.73-2.57-1.07l-0.91-0.37c-0.85-0.32-1.7-0.59-2.55-0.86l-1.05-0.34c-0.94-0.26-1.85-0.48-2.77-0.68 l-0.94-0.22c-0.76-0.17-1.55-0.28-2.32-0.38l-1.49-0.22c-0.9-0.1-1.72-0.13-2.5-0.17l-2-0.08c-1.09,0-2.12,0.07-3.28,0.2 c-1.32,0.15-2.62,0.37-3.87,0.68c-1.09,0.26-2.28,0.62-3.72,1.15c-1.17,0.45-2.32,0.97-3.54,1.59 c-0.29,0.15-0.58,0.31-0.86,0.48l-0.83,0.49c-0.38,0.22-0.78,0.47-1.17,0.74l-0.44,0.28l-1.55,1.14l-1.47,1.22l-1.4,1.29 l-1.32,1.35l-1.24,1.44c0,0-2.07,2.41-3.68,5.14c1.68,0,43.85,0.06,43.85,0.06l-1.94,12.24c-7.36,0.01-41.97,0.05-45.1,0.05 c-0.51,1.77-0.62,3.82-0.61,5.62c0.01,2.1,0.22,3.91,0.67,5.54c1.4,0,43.27,0,43.27,0l-1.95,12.29c0,0-33.75,0-38.19,0 c0.97,2.69,4.68,6.76,4.68,6.76l1.29,1.32l1.39,1.27l1.45,1.19l1.55,1.11l1.57,1.02l1.65,0.93l1.7,0.85l1.76,0.73l1.81,0.62 l1.82,0.52l1.89,0.41l1.89,0.29l1.95,0.17l1.86,0.05l2.01-0.08c0.65-0.02,1.31-0.05,1.96-0.09l2.45-0.31 c0.72-0.09,1.13-0.14,1.53-0.23l2.52-0.56c0.47-0.09,0.92-0.2,1.35-0.34l1.84-0.59c0.25-0.1,0.42-0.14,0.58-0.2 c0.67-0.22,1.05-0.35,1.38-0.51l2.38-1.06c0.41-0.17,0.85-0.37,1.23-0.63l2.04-1.18c0.58-0.32,0.98-0.55,1.33-0.82l1.92-1.41 c0.45-0.32,0.85-0.61,1.2-0.93l0.63-0.58l9.93,20.87l-2.05,1.67c-0.22,0.2-0.38,0.33-0.55,0.46c0,0-3.31,2.29-3.62,2.49 l-2.37,1.39c-0.67,0.4-1.37,0.82-2.16,1.17l-1.65,0.78c-0.54,0.26-1.08,0.52-1.59,0.73l-3.34,1.25c-0.68,0.28-1.35,0.47-2,0.65 c-0.57,0.16-0.98,0.27-1.39,0.41l-0.52,0.15c-0.38,0.12-0.75,0.23-1.13,0.32l-4.32,0.94l-4.49,0.63 c-1.49,0.16-3.32,0.34-5.18,0.34c-0.57,0-1.14-0.02-1.69-0.05c-2.79-0.17-5-0.45-6.94-0.86c-2.57-0.53-4.77-1.14-6.76-1.84 c-0.8-0.24-1.56-0.53-2.29-0.81c-0.35-0.14-0.74-0.29-1.14-0.43l-3.88-1.63l-0.47-0.22c-0.69-0.33-1.39-0.65-2.07-1l-0.88-0.47 c-0.73-0.38-1.44-0.76-2.15-1.19l-3.41-2.16c-0.86-0.6-1.63-1.14-2.36-1.74l-1.41-1.12c-0.23-0.2-0.5-0.43-0.75-0.67l-1.8-1.62 l-1.68-1.67c-0.26-0.26-0.52-0.52-0.71-0.75l-1.96-2.18c-0.52-0.57-1.06-1.17-1.53-1.79c0,0-1.82-2.26-2.21-2.76l-1.97-2.8 l-1.78-2.98c-0.18-0.29-0.32-0.58-0.46-0.88L355,183c-0.3-0.57-0.51-1.04-0.71-1.5c-0.98-2.14-1.76-4.45-2.43-6.45l-0.57-1.8 h-12.69l-0.01,0.01l80,79.97c0.79-0.14,1.56-0.33,2.34-0.49l0.02,0.02c0.21-0.05,0.41-0.11,0.62-0.16 c2.44-0.53,4.85-1.14,7.21-1.86c0.06-0.02,0.12-0.04,0.18-0.06c2.21-0.67,4.38-1.43,6.51-2.26c35.44-13.5,61.32-46.59,64.2-86 L441.8,104.53z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "Graphic_x0020_Style_x0020_2",
    d: "M349.17,159.23c-0.04-0.71-0.25-4.43,0.21-7.56l0.27-1.86H338.6l10.65,10.65 L349.17,159.23z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Graphic_x0020_Style_x0020_2",
    d: "M441.8,104.53L441.8,104.53l-9.95,23.81l-0.33-0.22l-3.25-1.85l-3.38-1.64 c-0.87-0.38-1.72-0.73-2.57-1.07l-0.91-0.37c-0.85-0.32-1.7-0.59-2.55-0.86l-1.05-0.34c-0.94-0.26-1.85-0.48-2.77-0.68 l-0.94-0.22c-0.76-0.17-1.55-0.28-2.32-0.38l-1.49-0.22c-0.9-0.1-1.72-0.13-2.5-0.17l-2-0.08c-1.09,0-2.12,0.07-3.28,0.2 c-1.32,0.15-2.62,0.37-3.87,0.68c-1.09,0.26-2.28,0.62-3.72,1.15c-1.17,0.45-2.32,0.97-3.54,1.59 c-0.29,0.15-0.58,0.31-0.86,0.48l-0.83,0.49c-0.38,0.22-0.78,0.47-1.17,0.74l-0.44,0.28l-1.55,1.14l-1.47,1.22l-1.4,1.29 l-1.32,1.35l-1.24,1.44c0,0-2.07,2.41-3.68,5.14c1.68,0,43.85,0.06,43.85,0.06l-1.94,12.24c-7.36,0.01-41.97,0.05-45.1,0.05 c-0.51,1.77-0.62,3.82-0.61,5.62c0.01,2.1,0.22,3.91,0.67,5.54c1.4,0,43.27,0,43.27,0l-1.95,12.29c0,0-33.75,0-38.19,0 c0.97,2.69,4.68,6.76,4.68,6.76l1.29,1.32l1.39,1.27l1.45,1.19l1.55,1.11l1.57,1.02l1.65,0.93l1.7,0.85l1.76,0.73l1.81,0.62 l1.82,0.52l1.89,0.41l1.89,0.29l1.95,0.17l1.86,0.05l2.01-0.08c0.65-0.02,1.31-0.05,1.96-0.09l2.45-0.31 c0.72-0.09,1.13-0.14,1.53-0.23l2.52-0.56c0.47-0.09,0.92-0.2,1.35-0.34l1.84-0.59c0.25-0.1,0.42-0.14,0.58-0.2 c0.67-0.22,1.05-0.35,1.38-0.51l2.38-1.06c0.41-0.17,0.85-0.37,1.23-0.63l2.04-1.18c0.58-0.32,0.98-0.55,1.33-0.82l1.92-1.41 c0.45-0.32,0.85-0.61,1.2-0.93l0.63-0.58l9.93,20.87l-2.05,1.67c-0.22,0.2-0.38,0.33-0.55,0.46c0,0-3.31,2.29-3.62,2.49 l-2.37,1.39c-0.67,0.4-1.37,0.82-2.16,1.17l-1.65,0.78c-0.54,0.26-1.08,0.52-1.59,0.73l-3.34,1.25c-0.68,0.28-1.35,0.47-2,0.65 c-0.57,0.16-0.98,0.27-1.39,0.41l-0.52,0.15c-0.38,0.12-0.75,0.23-1.13,0.32l-4.32,0.94l-4.49,0.63 c-1.49,0.16-3.32,0.34-5.18,0.34c-0.57,0-1.14-0.02-1.69-0.05c-2.79-0.17-5-0.45-6.94-0.86c-2.57-0.53-4.77-1.14-6.76-1.84 c-0.8-0.24-1.56-0.53-2.29-0.81c-0.35-0.14-0.74-0.29-1.14-0.43l-3.88-1.63l-0.47-0.22c-0.69-0.33-1.39-0.65-2.07-1l-0.88-0.47 c-0.73-0.38-1.44-0.76-2.15-1.19l-3.41-2.16c-0.86-0.6-1.63-1.14-2.36-1.74l-1.41-1.12c-0.23-0.2-0.5-0.43-0.75-0.67l-1.8-1.62 l-1.68-1.67c-0.26-0.26-0.52-0.52-0.71-0.75l-1.96-2.18c-0.52-0.57-1.06-1.17-1.53-1.79c0,0-1.82-2.26-2.21-2.76l-1.97-2.8 l-1.78-2.98c-0.18-0.29-0.32-0.58-0.46-0.88L355,183c-0.3-0.57-0.51-1.04-0.71-1.5c-0.98-2.14-1.76-4.45-2.43-6.45l-0.57-1.8 h-12.69l-0.01,0.01l80,79.97c0.79-0.14,1.56-0.33,2.34-0.49l0.02,0.02c0.21-0.05,0.41-0.11,0.62-0.16 c2.44-0.53,4.85-1.14,7.21-1.86c0.06-0.02,0.12-0.04,0.18-0.06c2.21-0.67,4.38-1.43,6.51-2.26c35.44-13.5,61.32-46.59,64.2-86 L441.8,104.53z"
  }))))), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000049904683715818546810000015440152110704906661_",
    gradientUnits: "userSpaceOnUse",
    x1: 674.2927,
    y1: 339.6858,
    x2: 612.886,
    y2: 8.9963
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1A3763"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BCBEC0"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      display: "inline",
      fill: "url(#SVGID_00000049904683715818546810000015440152110704906661_)"
    },
    cx: 640,
    cy: 155,
    r: 100
  }), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "685.93,98.32 660.16,98.32 640.05,140.58 619.99,98.32 594.05,98.32 621.53,149.91 595.79,149.91  595.79,165.05 628.23,165.05 628.22,174.55 595.79,174.55 595.79,189.69 628.22,189.69 628.21,218.31 651.79,218.31 651.8,189.69  682.32,189.69 682.32,174.55 651.81,174.55 651.81,165.05 682.32,165.05 682.32,149.91 658.5,149.91  "
  })), _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000049182197120345610610000017842581599036898989_",
    filterUnits: "userSpaceOnUse",
    x: 595.78,
    y: 98.33,
    width: 144.22,
    height: 154.79
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 595.78,
    y: 98.33,
    width: 144.22,
    height: 154.79,
    id: "SVGID_00000111152102643199886380000010452327478674442892_",
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000049182197120345610610000017842581599036898989_)"
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000175323123581629716660000003407445646203798181_",
    gradientUnits: "userSpaceOnUse",
    x1: 624.2574,
    y1: 130.7522,
    x2: 723.0898,
    y2: 223.7511,
    gradientTransform: "matrix(0.9922 -7.800000e-03 -7.800000e-03 0.9922 4.4759 4.4759)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1084,
    style: {
      stopColor: "#FBFBFB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2161,
    style: {
      stopColor: "#EFEFEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3234,
    style: {
      stopColor: "#DBDBDB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4307,
    style: {
      stopColor: "#BFBFBF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5379,
    style: {
      stopColor: "#9B9B9B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6451,
    style: {
      stopColor: "#6F6F6F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7507,
    style: {
      stopColor: "#3B3B3B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8563,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000175323123581629716660000003407445646203798181_)"
    },
    points: "764.87,173.4 669.82,268.45  578.16,176.78 673.21,81.73  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline",
      mask: "url(#SVGID_00000111152102643199886380000010452327478674442892_)"
    }
  }, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "Graphic_x0020_Style_x0020_2",
    points: "628.22,174.54 628.23,165.05 595.79,165.05 605.28,174.54  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "Graphic_x0020_Style_x0020_2",
    d: "M739.94,152.33l-54-54l-0.08,0.12l-27.36,51.45h23.82v15.14h-30.51l0,9.5h30.51 v15.14H651.8l-0.01,28.63h-23.58l0.01-28.63h-32.4l-0.04,0.01l63.43,63.43c45.96-8.97,80.8-49.56,80.8-98.13 C740,154.1,740,153.2,739.94,152.33z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "Graphic_x0020_Style_x0020_2",
    points: "628.22,174.54 628.23,165.05 595.79,165.05 605.28,174.54  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "Graphic_x0020_Style_x0020_2",
    d: "M739.94,152.33l-54-54l-0.08,0.12l-27.36,51.45h23.82v15.14h-30.51l0,9.5h30.51 v15.14H651.8l-0.01,28.63h-23.58l0.01-28.63h-32.4l-0.04,0.01l63.43,63.43c45.96-8.97,80.8-49.56,80.8-98.13 C740,154.1,740,153.2,739.94,152.33z"
  }))))), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000021830183561401286620000013667823417903971766_",
    gradientUnits: "userSpaceOnUse",
    x1: 434.2948,
    y1: 579.6855,
    x2: 372.8884,
    y2: 248.9977
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1A3763"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BCBEC0"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      display: "inline",
      fill: "url(#SVGID_00000021830183561401286620000013667823417903971766_)"
    },
    cx: 400,
    cy: 395,
    r: 100
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M434.88,423.8c-3.15,1.62-5.7,2.78-7.96,3.54c-2.26,0.76-4.22,1.12-6.19,1.14c-1.97,0.03-3.95-0.28-6.24-0.85 c-2.29-0.57-4.89-1.4-8.1-2.43l-0.19-0.06l-0.19-0.06l-0.19-0.06l-0.19-0.06c-1.27-0.41-2.63-0.77-4.02-1.07 c-1.39-0.3-2.82-0.54-4.22-0.7c-1.4-0.15-2.78-0.22-4.07-0.19c-1.29,0.04-2.51,0.18-3.58,0.46c0.45-0.5,0.93-1.17,1.4-1.93 c0.47-0.76,0.94-1.62,1.38-2.5c0.43-0.88,0.83-1.78,1.16-2.62c0.33-0.85,0.58-1.64,0.74-2.3c0.23-0.98,0.43-1.96,0.6-2.94 c0.17-0.98,0.32-1.97,0.44-2.95c0.12-0.98,0.21-1.97,0.28-2.95c0.07-0.98,0.11-1.96,0.13-2.93h5.98h5.98h5.98h5.98v-5.35v-5.35 v-5.35v-5.35h-6.99h-6.99h-6.99h-6.99c-0.01-0.03-0.02-0.05-0.03-0.08c-0.01-0.03-0.02-0.05-0.03-0.08 c-0.01-0.03-0.02-0.05-0.03-0.08c-0.01-0.03-0.02-0.05-0.03-0.08c-0.6-1.39-1.14-2.94-1.58-4.56c-0.44-1.63-0.77-3.33-0.96-5.04 c-0.19-1.71-0.23-3.41-0.08-5.04s0.48-3.18,1.04-4.57c0.28-0.7,0.61-1.38,0.99-2.01c0.38-0.64,0.82-1.23,1.32-1.79 c0.5-0.55,1.07-1.06,1.71-1.51c0.64-0.45,1.36-0.85,2.17-1.19c1.08-0.45,2.19-0.76,3.3-0.92c1.11-0.17,2.21-0.2,3.29-0.11 c1.08,0.09,2.13,0.3,3.14,0.62s1.96,0.75,2.84,1.27c1.02,0.61,1.94,1.37,2.76,2.27c0.83,0.91,1.55,1.96,2.17,3.13 c0.62,1.18,1.13,2.49,1.53,3.91s0.69,2.96,0.85,4.6l5.56-0.56l5.56-0.56l5.56-0.56l5.56-0.56c-0.35-3.44-1.01-6.71-1.97-9.77 c-0.96-3.06-2.22-5.91-3.75-8.53c-1.53-2.61-3.35-4.99-5.42-7.1c-2.07-2.11-4.41-3.94-6.98-5.48c-2.41-1.44-4.96-2.56-7.6-3.36 c-2.64-0.8-5.36-1.29-8.12-1.45c-2.76-0.16-5.57,0-8.36,0.49c-2.8,0.49-5.59,1.3-8.32,2.44c-2.19,0.91-4.23,1.99-6.11,3.23 c-1.88,1.24-3.61,2.64-5.17,4.18c-1.56,1.54-2.95,3.24-4.16,5.07c-1.21,1.83-2.25,3.79-3.09,5.89c-1.02,2.53-1.71,5.08-2.15,7.6 c-0.44,2.52-0.62,5-0.61,7.4c0,2.4,0.19,4.71,0.5,6.88c0.3,2.17,0.72,4.2,1.19,6.03h-3.36h-3.36h-3.36h-3.36v5.35v5.35v5.35v5.35 h4.67h4.67h4.67h4.67c-0.08,2.66-0.5,5.38-1.27,8.06c-0.77,2.68-1.9,5.33-3.41,7.86c-1.51,2.53-3.4,4.95-5.71,7.17 c-2.3,2.22-5.02,4.25-8.16,5.99l2.34,5.06l2.34,5.06l2.34,5.06l2.34,5.06c0.87-0.49,1.66-0.93,2.39-1.33 c0.73-0.4,1.41-0.77,2.05-1.11c0.64-0.34,1.25-0.65,1.85-0.94c0.6-0.29,1.18-0.57,1.78-0.83c2.2-0.98,4.26-1.78,6.3-2.37 c2.04-0.59,4.05-0.97,6.16-1.11c2.11-0.14,4.31-0.04,6.73,0.33s5.04,1.01,8,1.95l0.19,0.06l0.19,0.06l0.19,0.06l0.19,0.06 c3.95,1.27,7.48,2.36,10.86,3.14c3.38,0.77,6.62,1.22,9.99,1.2s6.86-0.54,10.76-1.68c3.9-1.14,8.19-2.91,13.16-5.48l-2.56-4.97 l-2.56-4.97l-2.56-4.97L434.88,423.8z"
  })), _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000152943656493229220070000009470669749642446994_",
    filterUnits: "userSpaceOnUse",
    x: 354.85,
    y: 342,
    width: 143.49,
    height: 152.7
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 354.85,
    y: 342,
    width: 143.49,
    height: 152.7,
    id: "SVGID_00000070806894196962388760000010338372669225766814_",
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000152943656493229220070000009470669749642446994_)"
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000062157474620641373840000002232567938912505003_",
    gradientUnits: "userSpaceOnUse",
    x1: 366.2088,
    y1: 370.1169,
    x2: 469.0118,
    y2: 466.852,
    gradientTransform: "matrix(1.0086 8.600000e-03 8.600000e-03 1.0086 -3.8655 -3.8655)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1084,
    style: {
      stopColor: "#FBFBFB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2161,
    style: {
      stopColor: "#EFEFEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3234,
    style: {
      stopColor: "#DBDBDB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4307,
    style: {
      stopColor: "#BFBFBF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5379,
    style: {
      stopColor: "#9B9B9B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6451,
    style: {
      stopColor: "#6F6F6F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7507,
    style: {
      stopColor: "#3B3B3B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8563,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000062157474620641373840000002232567938912505003_)"
    },
    points: "515.59,425.94 425.06,516.46  326.29,417.68 416.81,327.16  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline",
      mask: "url(#SVGID_00000070806894196962388760000010338372669225766814_)"
    }
  }, _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "Graphic_x0020_Style_x0020_2",
    d: "M372.26,410.38c0.77-2.68,1.18-5.39,1.27-8.06h-4.67h-4.67h-4.67h-4.67 l14.65,14.65C370.66,414.83,371.62,412.62,372.26,410.38z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Graphic_x0020_Style_x0020_2",
    d: "M427.31,342L427.31,342L427.31,342c2.07,2.11,3.88,4.48,5.41,7.1 c1.53,2.61,2.79,5.47,3.75,8.53c0.96,3.06,1.62,6.33,1.97,9.77l-5.56,0.56l-5.56,0.56l-5.56,0.56l-5.56,0.56 c-0.17-1.64-0.45-3.17-0.85-4.6c-0.4-1.42-0.91-2.73-1.53-3.91c-0.62-1.18-1.35-2.23-2.17-3.13c-0.83-0.91-1.75-1.67-2.76-2.27 c-0.88-0.52-1.83-0.95-2.84-1.27c-1-0.32-2.06-0.53-3.14-0.62c-1.08-0.09-2.19-0.06-3.29,0.11c-1.11,0.17-2.21,0.47-3.3,0.92 c-0.81,0.34-1.53,0.74-2.17,1.19c-0.64,0.45-1.21,0.96-1.71,1.51c-0.5,0.55-0.94,1.15-1.32,1.79c-0.38,0.64-0.71,1.31-0.99,2.01 c-0.56,1.39-0.89,2.94-1.04,4.57c-0.14,1.63-0.1,3.33,0.08,5.04c0.19,1.71,0.52,3.41,0.96,5.04c0.44,1.63,0.98,3.17,1.58,4.56 c0.01,0.03,0.02,0.05,0.03,0.08c0.01,0.03,0.02,0.05,0.03,0.08c0.01,0.03,0.02,0.05,0.03,0.08c0.01,0.03,0.02,0.05,0.03,0.08 h6.99h6.99h6.99h6.99v5.35v5.35v5.35v5.35h-5.98h-5.98h-5.98h-5.98c-0.02,0.97-0.06,1.95-0.13,2.93 c-0.07,0.98-0.16,1.96-0.28,2.94c-0.12,0.98-0.27,1.97-0.44,2.95c-0.17,0.98-0.38,1.96-0.6,2.94c-0.16,0.67-0.41,1.46-0.74,2.3 c-0.33,0.85-0.72,1.75-1.16,2.62c-0.43,0.88-0.9,1.74-1.38,2.5c-0.47,0.76-0.95,1.43-1.4,1.93c1.07-0.27,2.29-0.42,3.58-0.46 c1.29-0.04,2.67,0.03,4.07,0.19c1.4,0.15,2.83,0.39,4.22,0.7c1.39,0.3,2.75,0.67,4.02,1.07l0.19,0.06l0.19,0.06l0.19,0.06 l0.19,0.06c3.21,1.03,5.81,1.86,8.1,2.43c2.29,0.57,4.27,0.88,6.24,0.85c1.97-0.03,3.94-0.38,6.19-1.14 c2.26-0.76,4.81-1.92,7.96-3.54l2.56,4.97l2.56,4.97l2.56,4.97l2.56,4.97c-4.97,2.56-9.27,4.34-13.16,5.48 c-3.9,1.14-7.39,1.65-10.76,1.68s-6.61-0.42-9.99-1.2c-3.38-0.77-6.91-1.87-10.86-3.14l-0.19-0.06l-0.19-0.06l-0.19-0.06 l-0.19-0.06c-2.96-0.94-5.58-1.58-8-1.95c-2.42-0.37-4.62-0.47-6.73-0.33c-2.11,0.14-4.12,0.52-6.16,1.11 c-2.04,0.59-4.1,1.39-6.3,2.37c-0.6,0.27-1.18,0.54-1.78,0.83c-0.6,0.29-1.2,0.6-1.85,0.94c-0.64,0.34-1.32,0.7-2.05,1.11 c-0.73,0.4-1.52,0.84-2.38,1.33l-0.01,0.02l43.03,43.03c45.67-3.33,82.9-37.47,90.97-81.67L427.31,342z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "Graphic_x0020_Style_x0020_2",
    d: "M372.26,410.38c0.77-2.68,1.18-5.39,1.27-8.06h-4.67h-4.67h-4.67h-4.67 l14.65,14.65C370.66,414.83,371.62,412.62,372.26,410.38z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Graphic_x0020_Style_x0020_2",
    d: "M427.31,342L427.31,342L427.31,342c2.07,2.11,3.88,4.48,5.41,7.1 c1.53,2.61,2.79,5.47,3.75,8.53c0.96,3.06,1.62,6.33,1.97,9.77l-5.56,0.56l-5.56,0.56l-5.56,0.56l-5.56,0.56 c-0.17-1.64-0.45-3.17-0.85-4.6c-0.4-1.42-0.91-2.73-1.53-3.91c-0.62-1.18-1.35-2.23-2.17-3.13c-0.83-0.91-1.75-1.67-2.76-2.27 c-0.88-0.52-1.83-0.95-2.84-1.27c-1-0.32-2.06-0.53-3.14-0.62c-1.08-0.09-2.19-0.06-3.29,0.11c-1.11,0.17-2.21,0.47-3.3,0.92 c-0.81,0.34-1.53,0.74-2.17,1.19c-0.64,0.45-1.21,0.96-1.71,1.51c-0.5,0.55-0.94,1.15-1.32,1.79c-0.38,0.64-0.71,1.31-0.99,2.01 c-0.56,1.39-0.89,2.94-1.04,4.57c-0.14,1.63-0.1,3.33,0.08,5.04c0.19,1.71,0.52,3.41,0.96,5.04c0.44,1.63,0.98,3.17,1.58,4.56 c0.01,0.03,0.02,0.05,0.03,0.08c0.01,0.03,0.02,0.05,0.03,0.08c0.01,0.03,0.02,0.05,0.03,0.08c0.01,0.03,0.02,0.05,0.03,0.08 h6.99h6.99h6.99h6.99v5.35v5.35v5.35v5.35h-5.98h-5.98h-5.98h-5.98c-0.02,0.97-0.06,1.95-0.13,2.93 c-0.07,0.98-0.16,1.96-0.28,2.94c-0.12,0.98-0.27,1.97-0.44,2.95c-0.17,0.98-0.38,1.96-0.6,2.94c-0.16,0.67-0.41,1.46-0.74,2.3 c-0.33,0.85-0.72,1.75-1.16,2.62c-0.43,0.88-0.9,1.74-1.38,2.5c-0.47,0.76-0.95,1.43-1.4,1.93c1.07-0.27,2.29-0.42,3.58-0.46 c1.29-0.04,2.67,0.03,4.07,0.19c1.4,0.15,2.83,0.39,4.22,0.7c1.39,0.3,2.75,0.67,4.02,1.07l0.19,0.06l0.19,0.06l0.19,0.06 l0.19,0.06c3.21,1.03,5.81,1.86,8.1,2.43c2.29,0.57,4.27,0.88,6.24,0.85c1.97-0.03,3.94-0.38,6.19-1.14 c2.26-0.76,4.81-1.92,7.96-3.54l2.56,4.97l2.56,4.97l2.56,4.97l2.56,4.97c-4.97,2.56-9.27,4.34-13.16,5.48 c-3.9,1.14-7.39,1.65-10.76,1.68s-6.61-0.42-9.99-1.2c-3.38-0.77-6.91-1.87-10.86-3.14l-0.19-0.06l-0.19-0.06l-0.19-0.06 l-0.19-0.06c-2.96-0.94-5.58-1.58-8-1.95c-2.42-0.37-4.62-0.47-6.73-0.33c-2.11,0.14-4.12,0.52-6.16,1.11 c-2.04,0.59-4.1,1.39-6.3,2.37c-0.6,0.27-1.18,0.54-1.78,0.83c-0.6,0.29-1.2,0.6-1.85,0.94c-0.64,0.34-1.32,0.7-2.05,1.11 c-0.73,0.4-1.52,0.84-2.38,1.33l-0.01,0.02l43.03,43.03c45.67-3.33,82.9-37.47,90.97-81.67L427.31,342z"
  }))))), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000090289953992794936410000014767392507058784154_",
    gradientUnits: "userSpaceOnUse",
    x1: 674.2948,
    y1: 579.6855,
    x2: 612.8884,
    y2: 248.9977
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1A3763"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BCBEC0"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      display: "inline",
      fill: "url(#SVGID_00000090289953992794936410000014767392507058784154_)"
    },
    cx: 640,
    cy: 395,
    r: 100
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M628.05,402.1l0.33-0.04h19.87c15.44,0,25.99-3.32,32.26-10.14c6.09-6.63,9.18-14.8,9.18-24.31 c0-5.55-1.16-10.73-3.44-15.41c-1.61-3.28-3.61-6.1-5.97-8.41c-1.06-1.03-2.18-1.96-3.38-2.79c-3.8-2.63-8.48-4.42-13.91-5.33 c-3.76-0.68-8.96-1.02-15.88-1.02h-41.71v47.28h-15.06v20.16h15.06v7.97h-15.06v20.16h15.06v25.09h21.54v-25.09h42.63v-20.16 h-42.63v-7.97H628.05z M659.34,355.51c2.5,0.69,4.46,2.08,6.01,4.25c1.6,2.26,2.38,4.96,2.38,8.26c0,4.53-1.29,7.87-3.95,10.23 c-2.73,2.42-8.03,3.69-15.33,3.69h-21.52v-27.16h21.25C655.49,354.78,658.31,355.23,659.34,355.51z"
  })), _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000049922526640506567960000004459572799812622998_",
    filterUnits: "userSpaceOnUse",
    x: 590.33,
    y: 343.86,
    width: 149.3,
    height: 151.01
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 590.33,
    y: 343.86,
    width: 149.3,
    height: 151.01,
    id: "SVGID_00000178902011063653027750000005248978503752198587_",
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000049922526640506567960000004459572799812622998_)"
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000002381584121929175290000003363083639946637721_",
    gradientUnits: "userSpaceOnUse",
    x1: 611.266,
    y1: 370.9879,
    x2: 708.3636,
    y2: 462.3575,
    gradientTransform: "matrix(0.9972 -2.800000e-03 -2.800000e-03 0.9972 1.5081 1.5081)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1084,
    style: {
      stopColor: "#FBFBFB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2161,
    style: {
      stopColor: "#EFEFEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3234,
    style: {
      stopColor: "#DBDBDB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4307,
    style: {
      stopColor: "#BFBFBF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5379,
    style: {
      stopColor: "#9B9B9B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6451,
    style: {
      stopColor: "#6F6F6F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7507,
    style: {
      stopColor: "#3B3B3B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8563,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000002381584121929175290000003363083639946637721_)"
    },
    points: "759.79,418.16 661.46,516.49  562.15,417.18 660.48,318.85  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline",
      mask: "url(#SVGID_00000178902011063653027750000005248978503752198587_)"
    }
  }, _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "Graphic_x0020_Style_x0020_2",
    d: "M659.34,355.51c-1.03-0.27-3.86-0.73-11.16-0.73h-21.25v27.16h21.52 c7.3,0,12.61-1.28,15.33-3.69c2.66-2.35,3.95-5.7,3.95-10.23c0-3.3-0.78-6-2.38-8.26C663.81,357.59,661.84,356.2,659.34,355.51z "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "Graphic_x0020_Style_x0020_2",
    points: "605.39,410.07 605.39,402.1 590.33,402.1 598.3,410.07  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "Graphic_x0020_Style_x0020_2",
    d: "M680.33,343.86c2.34,2.3,4.32,5.09,5.91,8.34c2.29,4.67,3.44,9.86,3.44,15.41 c0,9.5-3.09,17.68-9.18,24.31c-6.27,6.82-16.82,10.14-32.26,10.14h-19.87l-0.33,0.04h-1.11v7.97h42.63v20.16h-42.63v25.09H605.4 l0,0.01l39.53,39.53c50.13-2.43,90.7-42,94.7-91.73L680.33,343.86z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "Graphic_x0020_Style_x0020_2",
    points: "605.39,430.23 590.33,430.23 605.39,445.29  "
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "Graphic_x0020_Style_x0020_2",
    d: "M659.34,355.51c-1.03-0.27-3.86-0.73-11.16-0.73h-21.25v27.16h21.52 c7.3,0,12.61-1.28,15.33-3.69c2.66-2.35,3.95-5.7,3.95-10.23c0-3.3-0.78-6-2.38-8.26C663.81,357.59,661.84,356.2,659.34,355.51z "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "Graphic_x0020_Style_x0020_2",
    points: "605.39,410.07 605.39,402.1 590.33,402.1 598.3,410.07  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "Graphic_x0020_Style_x0020_2",
    d: "M680.33,343.86c2.34,2.3,4.32,5.09,5.91,8.34c2.29,4.67,3.44,9.86,3.44,15.41 c0,9.5-3.09,17.68-9.18,24.31c-6.27,6.82-16.82,10.14-32.26,10.14h-19.87l-0.33,0.04h-1.11v7.97h42.63v20.16h-42.63v25.09H605.4 l0,0.01l39.53,39.53c50.13-2.43,90.7-42,94.7-91.73L680.33,343.86z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "Graphic_x0020_Style_x0020_2",
    points: "605.39,430.23 590.33,430.23 605.39,445.29  "
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000013170412264399638760000013209329800767029900_",
    gradientUnits: "userSpaceOnUse",
    x1: 434.2956,
    y1: 459.6858,
    x2: 372.8889,
    y2: 128.9963
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1A3763"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BCBEC0"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000013170412264399638760000013209329800767029900_)"
    },
    cx: 400,
    cy: 275,
    r: 100
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M444.5,278.5c-3.07-3.67-7.37-6.33-12.2-8.13c6.27-4.97,10.7-11.43,10.7-18.53c0-9.6-4.63-15.67-10.97-19.37 c-6.33-3.73-14.33-5.1-21.1-5.23v-20.7h-13v20.67h-8.57v-20.67h-13v20.67h-25.8v13.57h11.93c2.4,0,4.33,1.97,4.33,4.37v59.77 c0,2.4-1.93,4.37-4.33,4.37h-10.6l-1.33,13.57h25.8v20.67h13v-20.6h8.57v20.6h13v-20.6h8.3c16.67,0,30.2-10.77,30.2-30.2 C449.43,286.83,447.57,282.17,444.5,278.5z M418.07,254.4c0,3.5-1.43,6.67-3.7,8.97c-2.3,2.3-5.47,3.73-8.97,3.73h-16.03v-25.67 h15.73C412.27,241.43,418.07,247.23,418.07,254.4z M410.87,307.77H390.1c-0.4,0-0.73-0.33-0.73-0.73v-26.17 c0-0.4,0.33-0.73,0.73-0.73h20.43c7.73,0,14,6.27,14,13.97C424.53,301.67,418.4,307.77,410.87,307.77z"
  })), _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000005955812453917259020000017483258777008976008_",
    filterUnits: "userSpaceOnUse",
    x: 350.57,
    y: 206.53,
    width: 147.67,
    height: 168.4
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 350.57,
    y: 206.53,
    width: 147.67,
    height: 168.4,
    id: "SVGID_00000086657906060264281860000007807807389138272669_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000005955812453917259020000017483258777008976008_)"
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000062902665851001051820000000740462652663971232_",
    gradientUnits: "userSpaceOnUse",
    x1: 347.0093,
    y1: 234.4384,
    x2: 468.5649,
    y2: 348.8193,
    gradientTransform: "matrix(1.0072 7.200000e-03 7.200000e-03 1.0072 -2.2865 -2.2865)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1084,
    style: {
      stopColor: "#FBFBFB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2161,
    style: {
      stopColor: "#EFEFEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3234,
    style: {
      stopColor: "#DBDBDB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4307,
    style: {
      stopColor: "#BFBFBF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5379,
    style: {
      stopColor: "#9B9B9B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6451,
    style: {
      stopColor: "#6F6F6F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7507,
    style: {
      stopColor: "#3B3B3B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8563,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000062902665851001051820000000740462652663971232_)"
    },
    points: "515.75,306.05 422.21,399.6  305.32,282.7 398.86,189.16  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#SVGID_00000086657906060264281860000007807807389138272669_)"
    }
  }, _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "Graphic_x0020_Style_x0020_2",
    d: "M405.1,241.43h-15.73v25.67h16.03c3.5,0,6.67-1.43,8.97-3.73 c2.27-2.3,3.7-5.47,3.7-8.97C418.07,247.23,412.27,241.43,405.1,241.43z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "Graphic_x0020_Style_x0020_2",
    points: "397.93,227.2 397.93,215.1 389.37,206.53 389.37,227.2  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "Graphic_x0020_Style_x0020_2",
    d: "M390.1,307.77h20.77c7.53,0,13.67-6.1,13.67-13.67c0-7.7-6.27-13.97-14-13.97 H390.1c-0.4,0-0.73,0.33-0.73,0.73v26.17C389.37,307.43,389.7,307.77,390.1,307.77z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Graphic_x0020_Style_x0020_2",
    d: "M366.83,245.13c0-2.4-1.93-4.37-4.33-4.37h-11.93l16.27,16.27V245.13z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Graphic_x0020_Style_x0020_2",
    d: "M410.93,206.53v20.7c6.77,0.13,14.77,1.5,21.1,5.23 c6.33,3.7,10.97,9.77,10.97,19.37c0,7.1-4.43,13.57-10.7,18.53c4.83,1.8,9.13,4.47,12.2,8.13c3.07,3.67,4.93,8.33,4.93,14.2 c0,19.43-13.53,30.2-30.2,30.2h-8.3v20.6h-13v-20.6h-8.57v20.6h-13v-20.67h-25.8l52.13,52.1c0.2,0,0.4,0,0.6-0.03 c0.7,0,1.4-0.03,2.1-0.07c1.47-0.07,2.93-0.17,4.37-0.33c42.13-4.1,76.73-34.47,87.07-74.5c0.53-2.03,1-4.1,1.4-6.2 L410.93,206.53z"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "Graphic_x0020_Style_x0020_2",
    d: "M405.1,241.43h-15.73v25.67h16.03c3.5,0,6.67-1.43,8.97-3.73 c2.27-2.3,3.7-5.47,3.7-8.97C418.07,247.23,412.27,241.43,405.1,241.43z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "Graphic_x0020_Style_x0020_2",
    points: "397.93,227.2 397.93,215.1 389.37,206.53 389.37,227.2  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "Graphic_x0020_Style_x0020_2",
    d: "M390.1,307.77h20.77c7.53,0,13.67-6.1,13.67-13.67c0-7.7-6.27-13.97-14-13.97 H390.1c-0.4,0-0.73,0.33-0.73,0.73v26.17C389.37,307.43,389.7,307.77,390.1,307.77z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Graphic_x0020_Style_x0020_2",
    d: "M366.83,245.13c0-2.4-1.93-4.37-4.33-4.37h-11.93l16.27,16.27V245.13z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Graphic_x0020_Style_x0020_2",
    d: "M410.93,206.53v20.7c6.77,0.13,14.77,1.5,21.1,5.23 c6.33,3.7,10.97,9.77,10.97,19.37c0,7.1-4.43,13.57-10.7,18.53c4.83,1.8,9.13,4.47,12.2,8.13c3.07,3.67,4.93,8.33,4.93,14.2 c0,19.43-13.53,30.2-30.2,30.2h-8.3v20.6h-13v-20.6h-8.57v20.6h-13v-20.67h-25.8l52.13,52.1c0.2,0,0.4,0,0.6-0.03 c0.7,0,1.4-0.03,2.1-0.07c1.47-0.07,2.93-0.17,4.37-0.33c42.13-4.1,76.73-34.47,87.07-74.5c0.53-2.03,1-4.1,1.4-6.2 L410.93,206.53z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBitcoin);
export default __webpack_public_path__ + "static/media/bitcoin.4dc9f56b7ea0355fd0fdba5b0363072b.svg";
export { ForwardRef as ReactComponent };